export const ADDONS_ACTIONS = {
    DELETE: 'delete',
    SAVE: 'save',
    SEARCH: 'search',
    FETCH_ACTION: 'normal'
}

export const ALL_ADD_ON_TYPES_MAP : Record<string, { name: string; mid: string }> = {
  upsell: { name: "Upsell", mid: "Upsell" },
  recipe: { name: "Recipe", mid: "Recipe" },
}
